export default __webpack_public_path__ + "static/CynosureWealth_Logo_White-26c65529773166b4216385e4a913efce.png";